<template>
  <v-card class="rounded-lg white">
    <v-card-title>جزئیات محصول شریک</v-card-title>
    <v-card-text>
      <div v-if="!partnerId" class="text-center py-12 grey--text">
        اول از صفحه‌ی «خلاصه محصولات» یک شریک را انتخاب کنید.
      </div>

      <div v-else class="admin-dark-panel rounded-lg pa-3 mt-2">
        <PartnerCalculationsProductDetail
            :key="`${partnerId}-${productId}`"
            :partner-id="partnerId"
            :product-id-prop="productId"
            @back="goBack"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import PartnerCalculationsProductDetail from "./PartnerCalculationsProductDetail"
import adminPartnerSelection from "./adminPartnerSelectionMixin"

export default {
  name: 'AdminPartnerCalculationsProductDetailPage',

  mixins: [adminPartnerSelection],

  components: { PartnerCalculationsProductDetail },

  computed: {
    productId() {
      return this.$route.params.productId
    },
  },

  methods: {
    goBack() {
      this.$router.push({ name: 'AdminPartnerCalculationsProducts' })
    },
  },
}
</script>

<style scoped>
.admin-dark-panel {
  background-color: #111827;
}
</style>
